import { render, staticRenderFns } from "./suspension_diagram.vue?vue&type=template&id=6945baa0&scoped=true"
import script from "./suspension_diagram.vue?vue&type=script&lang=js"
export * from "./suspension_diagram.vue?vue&type=script&lang=js"
import style0 from "./suspension_diagram.vue?vue&type=style&index=0&id=6945baa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945baa0",
  null
  
)

export default component.exports